import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import "sharect";

const ArticleWrap = () => {
	const block = document.querySelector(".article-wrap");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollToPlugin);
	const progress = block.querySelector(".article-wrap__progress");
	const body = document.querySelector("body");
	const goTop = block.querySelector(".article-wrap__go-top");
	const pageNav = block.querySelector(".article-wrap__page-nav");
	const content = block.querySelector(".article-wrap__content");
	const titles = content.querySelectorAll("h1, h2, h3, h4, h5, h6");
	const audio = block.querySelector(".article-wrap__audio");
	const audioWidget = block.querySelector(".article-wrap__audio .audio-widget");
	const aside = block.querySelector(".article-wrap__aside");
	const headInner = block.querySelector(".article-wrap__head-inner");
	const breadcrumbsGlobal = document.querySelector(".breadcrumbs__global");

	if (breadcrumbsGlobal && headInner) {
		headInner.closest(".container").prepend(breadcrumbsGlobal);
	}

	Sharect.config({
		facebook: true,
		twitter: true,
		backgroundColor: "#000000",
		iconColor: "#ffffff",
		selectableElements: [".rich-text"],
	}).init();

	document.addEventListener("scroll", () => {
		const pixels = window.scrollY;
		const pageHeight = body.getBoundingClientRect().height;
		const totalHeight = pageHeight - window.innerHeight;
		const percentage = pixels / totalHeight;
		
		progress.style.width = `${100 * percentage}%`
	});

	if (audio) {
		const handleStickyAudioWidget = () => {
			if (window.scrollY > window.innerHeight) {
				audio.classList.add("article-wrap__audio_sticky");
				audioWidget.style.width = `${aside.offsetWidth - 32}px`;
			} else {
				audio.classList.remove("article-wrap__audio_sticky");
				audioWidget.style.width = "100%";
			}
		};
		handleStickyAudioWidget();

		window.addEventListener("scroll", (e) => {
			handleStickyAudioWidget();
		});

		window.addEventListener("resize", (e) => {
			// audioWidget.style.width = `${aside.offsetWidth - 32}px`;
			handleStickyAudioWidget();
		});
	}

	if (goTop) {
		goTop.addEventListener("click", (e) => {
			gsap.to(window, { scrollTo: 0, duration: 0.5 });
		});

		const handleGoTopVisible = () => {
			if (window.scrollY > window.innerHeight / 2) {
				goTop.classList.add("active");
			} else {
				goTop.classList.remove("active");
			}
		};

		handleGoTopVisible();
		window.addEventListener("scroll", (e) => {
			handleGoTopVisible();
		});
	}

	if (pageNav) {
		// set title in page nav
		titles.forEach((title, index) => {
			const ignoreTitle = title.closest(".page-nav-ignore");

			if (!ignoreTitle) {
				const navItem = document.createElement("div");
				navItem.classList.add("article-wrap__page-nav-item");

				title.setAttribute("id", `article-heading-${index + 1}`);
				title.classList.add("content-heading");
				navItem.innerHTML = `<a class='article-wrap__page-nav-link heading-${title.tagName.toLowerCase()}' href='#article-heading-${index + 1}'>${title.textContent}</a>`;
				pageNav.append(navItem);
			}
		});

		// page nav click
		document.addEventListener("click", (e) => {
			if (e.target.classList.contains("article-wrap__page-nav-link")) {
				e.preventDefault();

				const target = document.querySelector(e.target.getAttribute("href"));
				const header = document.querySelector(".header");
				let offsetY = 0;
				if (target.classList.contains("job-card__title")) {
					offsetY = 100;
				}

				gsap.to(window, {
					duration: 0.5,
					scrollTo: {
						y: target,
						offsetY: header.offsetHeight + 20 + offsetY
					}
				});
			}
		});

		// scrollspy
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				const id = entry.target.getAttribute('id');
				const navLink = document.querySelector(`.article-wrap__page-nav-link[href="#${id}"]`);
				if (navLink) {
					if (entry.intersectionRatio > 0) {
						navLink.parentElement.classList.add('active');
					} else {
						navLink.parentElement.classList.remove('active');
					}
				}
			});
		});
		document.querySelectorAll(".content-heading").forEach((section) => {
			observer.observe(section);
		});
	}
};

export default ArticleWrap;
